export default __webpack_public_path__ + "static/media/flask.b895607b.svg";